NtechApp.SearchLauncher = function($view, $snapLauncherFrom) {
    var me = this;

    this._click = null;
    this._$view = null;
    this._$snapLauncherFrom = null;

    this._construct = function () {
        me._click = new NtechApp.TouchClickEvent();
        me._$view = $view;
        me._$snapLauncherFrom = $snapLauncherFrom;

        me._bindEvents();
    }

    this._bindEvents = function () {
        me._click.listen(me._$view, function(event) {
            var $launcher = $(event).target;

            $(window).trigger(NtechApp.SearchLauncher.EVENT_SELECT, [{
                isSearchLauncher: function() {
                    return !$launcher.hasClass("filtersSearchLauncher");
                },
                isFiltersLauncher: function() {
                    return $launcher.hasClass("filtersSearchLauncher");
                }
            }]);
        });

        $(window).on(NtechApp.SearchLauncher.EVENT_DOCUMENT_RESIZE, function() {
            me._updateLauncherPosition();
            //me._centrifySideNavigationContent();
        });

        $(document).on(NtechApp.SearchLauncher.EVENT_DOCUMENT_SCROLL, function() {
            me._updateLauncherPosition();
            //me._centrifySideNavigationContent();
        });
    }

    this._unbindEvents = function () {
        ;
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.SearchLauncher.EVENT_SELECT = "NtechApp.SearchLauncher.EventSelect";
NtechApp.SearchLauncherTypes = {SEARCH: 0, FILTERS: 1};
NtechApp.SearchLauncher.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.SearchLauncher";
NtechApp.SearchLauncher.EVENT_DOCUMENT_RESIZE = "resize.NtechApp.SearchLauncher";

NtechApp.proto(NtechApp.SearchLauncher, {
    _updateLauncherPosition: function() {
        if($(window).scrollTop() > this._$snapLauncherFrom.outerHeight() - 15)
            this._$view.addClass("snapToViewportTop");
        else
            this._$view.removeClass("snapToViewportTop");
    }
});